import React from 'react'
import classes from './Backdrop.module.css'

export default props => <div className={classes.Backdrop} onClick={props.onClick}></div>